<template>
  <div>
    <span style="display: none">{{ status }}</span>
    <c-row class="mb-3">
      <c-col>
        <c-button class="btn btn-primary float-left" size="sm" @click="get(1)">
          <c-spinner v-if="isLoading" color="success" size="sm" />
          <span v-else>Refresh</span>
        </c-button>
        <c-button class="btn btn-primary float-right" size="sm" @click="runBackup('database', 'cron')">
          <c-spinner v-if="isRunningBackup" color="success" size="sm" />
          <span v-else>Run database backup</span>
        </c-button>
        <c-button class="btn btn-primary float-right mr-2" size="sm" @click="runBackup('files')">
          <c-spinner v-if="isRunningBackup" color="success" size="sm" />
          <span v-else>Run files backup</span>
        </c-button>
      </c-col>
    </c-row>
    <template v-if="!isLoading && !backups.length">
      <p class="lead">No site backups have been run.</p>
    </template>
    <template v-else>
      <table v-if="backups.length" class="table">
        <thead>
          <tr>
            <th style="width: 200px">Date</th>
            <th>Type</th>
            <th>Status</th>
            <th>Info</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="backup in backups">
            <td>{{ backup.createdAt | dateFormatWithTime }}</td>
            <td>{{ backup.backupType }}</td>
            <td>{{ backup.status }}</td>
            <td>
              <template v-if="backup.status === 'completed'">
                finished backup
              </template>
              <template v-if="backup.status === 'running'">
                {{ backup.info }}
                <c-spinner color="success" size="sm" />
              </template>
              <template v-else>
                <!--              Anything to go here? -->
              </template>
            </td>
            <td>
              <c-button  v-if="backup.status === 'completed'" class="btn btn-primary float-right mr-2" size="sm" @click="download(backup)">
                <c-spinner v-if="backup.isDownloading" color="success" size="sm" />
                <span v-else>Download</span>
              </c-button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>

import io from 'socket.io-client';
import Vue from 'vue';
import { buildEndpoint } from '@/libs/buildEndPoint';

const socket = io(buildEndpoint(''));

export default {
  name: 'BackupsList',
  props: {
    siteId: String,
  },
  data() {
    return {
      isLoading: false,
      isRunningBackup: false,
      pages: {},
      backups: [],
      status: '',
    };
  },
  mounted() {
    this.get();
  },
  created() {
    this.siteId = this.$route.params.siteId;
    const _this = this;
    socket.emit('room', Vue.localStorage.get('mp-sid'));
    socket.on('siteBackupNotification', (data) => {
      // _this.get()
      // Update backup status of site
      const backup = _this.backups.find((b) => (b._id = data.backupId));
      if (backup) {
        backup.status = data.status;
        backup.tableCountBackedUp = data.tableCountBackedUp;
        backup.directoryCountBackedUp = data.directoryCountBackedUp;
        backup.percentageBackedUp = data.percentageBackedUp;
        backup.info = `Backing up: ${(backup.percentageBackedUp * 100).toFixed(2)}%`;
        // @TODO - this is a complete bodge to force the data in the array to be reactive.
        // @TODO - find a better way to do this. Seriously. There is a hidden element above the table, if this is
        // @TODO - not there, the array data will not update in the table.
        _this.status = backup.info;
      }
      // if (['refresh-site'].indexOf(data.action) !== -1 && _this.siteId === data.siteId) {
      // _this.isUpdatingAllPlugins = false
      // _this.refreshSite()
      // _this.refreshPluginLogs++
      // }
    });
  },

  methods: {
    runBackup(type, when) {
      this.isRunningBackup = true;
      this.$http
        .get(buildEndpoint(`site/backups/run/${type}/${this.siteId}/${when}`))
        .then((response) => {
          this.isRunningBackup = false;
          if (response.data.success) {
            this.get();
          } else {
            this.error = 'Error running backup';
            this.$store.commit('addErrorMessage', {
              header: 'Error starting backup',
              message: response.data.error,
            });
          }
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit('addErrorMessage', {
            header: 'Error starting backup',
            message: error,
          });
        });
    },
    get(pageNum) {
      pageNum = pageNum || 1;
      this.isLoading = true;
      this.error = null;
      this.$http
        .get(`${buildEndpoint('site/backups/list/') + this.siteId}?page=${pageNum}`)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.backups = response.data.data.map((b) => {
              b.isDownloading = false;
              return b;
            });
            // const data = response.data.data
            // this.pluginUpdateLogs = data.docs
            // let pageList = []
            // for (let i = 1; i <= data.pages; i++) {
            //   if (i > data.page - 5 && i < data.page + 5) {
            //     pageList.push(i)
            //   }
            // }
            // this.pages = {
            //   numPages: data.pages,
            //   currentPage: data.page,
            //   totalDocs: data.total,
            //   pageList: pageList
            // }
          } else {
            this.error = 'Error getting backups';
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    download(file) {
      const fileToDownload = this.backups.find((backup) => backup._id === file._id);
      fileToDownload.isDownloading = true;
      this.$http
        .get(buildEndpoint(`site/backups/request-zip/${file._id}`))
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: "You're download has been requested.",
              message: "We'll send you an email when it's ready!",
            });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'There was an error downloading the file',
              message: response.data.error || '',
            });
          }
        })
        .catch(() => {
          this.$store.commit('addErrorMessage', {
            header: 'There was an error downloading the file',
          });
        }).finally(() => {
          fileToDownload.isDownloading = false;
        });
    },
  },
};
</script>
